import { Page, StyleSheet, Text, View } from '@react-pdf/renderer';
import moment from 'moment';
import React, { Fragment } from 'react';
import { getClientConfig, isEmpty } from '../../../generalFunctions';
import dayjs from 'dayjs';
import { FIRM_NAME } from '../../../constants';

const styles = StyleSheet.create({
    rowView: {
        flexDirection: 'row', border: '1px solid #000', padding: 7, textAlign: "justify", alignSelf: "flex-start", marginRight: 5, flex: 1
    }
});

const ReleaseOrderRegister = (props) => {
    const { caption, publication } = getClientConfig();

    let formattedData = [];
    let alreadyFilteredRos = [];

    const formatPartyBillData = (billData) => {
        let stringBillData = "";
        billData.forEach((bill, index) => {
            stringBillData = index === 0 ?
                stringBillData + bill.partyBillId + " " + bill.partyBillAmount
                : stringBillData + "\n" + bill.partyBillId + " " + bill.partyBillAmount;
        });
        return stringBillData;
    }

    const formatPublicationBillData = (billData) => {
        let stringBillData = "";
        billData.forEach((bill, index) => {
            stringBillData = index === 0 ?
                stringBillData + bill.billNumber + " " + bill.pubBillAmount
                : stringBillData + "\n" + bill.billNumber + " " + bill.pubBillAmount;
        });
        return stringBillData;
    }

    props.data?.forEach(ro => {
        if (!alreadyFilteredRos.includes(ro.roId)) {
            let roWithSameIds = props.data.filter(r => r.roId === ro.roId);
            let currentRO = { ...roWithSameIds[0] };
            currentRO.partyBills = [];
            currentRO.publicationBills = [];
            let alreadyFilteredPartyBills = [], alreadyFilteredPublicationBills = [];
            roWithSameIds.forEach(filteredRo => {
                if (filteredRo.partyBillId && !alreadyFilteredPartyBills.includes(filteredRo.partyBillId)) {
                    currentRO.partyBills.push({
                        partyBillId: filteredRo.partyBillId,
                        partyBillAmount: filteredRo.partyBillAmount
                    });
                    alreadyFilteredPartyBills.push(filteredRo.partyBillId);
                }
                if (filteredRo.billNumber && !alreadyFilteredPublicationBills.includes(filteredRo.billNumber)) {
                    currentRO.publicationBills.push({
                        billNumber: filteredRo.billNumber,
                        pubBillAmount: filteredRo.pubBillAmount
                    });
                    alreadyFilteredPublicationBills.push(filteredRo.billNumber);
                }
            });
            delete currentRO.partyBillId; delete currentRO.partyBillAmount; delete currentRO.billNumber; delete currentRO.pubBillAmount;
            formattedData.push(currentRO);
            alreadyFilteredRos.push(ro.roId);
        }
    });

    formattedData?.forEach((element, index) => {
        element.srno = index + 1;
        element.sizeCms = element.width + " * " + element.height;
        element.roDate = !isEmpty(element.roDate) ? moment(element.roDate).format("DD/MM/YYYY") : element.roDate;
        element.publication = element.publicationName;
        element.caption = props.pdfType === "releaseOrderRegister" ? element.captionName : "Classified";
        element.dateOfInsertion = !isEmpty(element.dateOfInsertion) && !element.dateOfInsertion.includes(",") ? dayjs(element.dateOfInsertion).format("DD-MM-YYYY") : element.dateOfInsertion.replace(/,/g, ",\n");
        // element.chqNumnAmt = element.chequeNumber + "  " + element.advanceAmount;
        element.ourBillnAmt = formatPartyBillData(element.partyBills);
        element.pubBillnAmt = formatPublicationBillData(element.publicationBills);
    });

    const tableData = {
        columnName: props.pdfType === "releaseOrderRegister" ?
            ["Sr", "RO Id", "Size", "Date", "Publication", "Client Name", "Type of Advt", "Release Date", "Our Bill No. & Amt.", "Cmp Bill No. & Amt.", "Rate"]
            : ["Sr", "RO Id", "Date", "Publication", "Client Name", "Bill For", "Release Date", "Our Bill No. & Amt.", "Company Bill No. & Amt.", "Rate"],
        column: props.pdfType === "releaseOrderRegister" ?
            ["srno", "roId", "sizeCms", "roDate", "publication", "clientName", "caption", "dateOfInsertion", "ourBillnAmt", "pubBillnAmt", "rate"]
            : ["srno", "roId", "roDate", "publication", "clientName", "billForName", "dateOfInsertion", "ourBillnAmt", "pubBillnAmt", "rate"],
        width: props.pdfType === "releaseOrderRegister" ?
            [2, 5, 5, 7, 17, 14, 13, 12, 10, 10, 5]
            : [2, 5, 7, 17, 17, 14, 12, 11, 10, 5],
        data: formattedData
    }

    return (
        <Page style={{ padding: 15 }} id={props.data.id} orientation="landscape" size="A4">
            <View style={{ flexDirection: "row", paddingBottom: 5, paddingTop: 7, alignSelf: "center" }}>
                <Text style={{
                    fontSize: 16,
                    flexDirection: "column",
                    flexGrow: 1
                }}>{FIRM_NAME}</Text>
            </View>
            <Fragment>
                <View style={{ flexDirection: 'row', border: '1px solid #000', padding: 7, textAlign: "left", alignSelf: "flex-start" }}>
                    {tableData["columnName"].map((c, index) => <Text key={index} style={{
                        width: `${tableData["width"][index]}%`, fontSize: 9, paddingRight: 7
                    }}>{c}</Text>)}
                </View>
                {tableData["data"].map((rowData) => <>
                    <View style={{ flexDirection: 'row', border: '1px solid #000', padding: 3, textAlign: "justify", alignSelf: "flex-start" }}>
                        {tableData["column"].map((c, index) =>
                            <Text key={index} style={{ width: `${tableData["width"][index]}%`, fontSize: 9, paddingRight: 5, paddingBottom: 3 }}>{rowData[c]}</Text>
                        )}
                    </View>
                </>)}
            </Fragment>
        </Page>
    );
}

export default ReleaseOrderRegister;